// Genera un SVG placeholder inline para cuando las imágenes externas fallan
// No depende de ningún servicio externo

const PALETTES = [
  { bg: "#0d0d2b", text: "#00ffe5" },
  { bg: "#2b0d0d", text: "#f87171" },
  { bg: "#1c1c3a", text: "#a78bfa" },
  { bg: "#1a2e1a", text: "#4ade80" },
  { bg: "#1a1208", text: "#fbbf24" },
  { bg: "#1a0a2e", text: "#e879f9" },
  { bg: "#0a1a1a", text: "#2dd4bf" },
  { bg: "#2b1a0d", text: "#fb923c" },
];

function hashCode(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = (Math.imul(31, h) + str.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

export function getSvgPlaceholder(title = "", width = 800, height = 450) {
  const palette = PALETTES[hashCode(title) % PALETTES.length];
  const fontSize = Math.max(14, Math.min(28, Math.floor(width / 18)));
  // Truncar título largo
  const label = title.length > 22 ? title.slice(0, 20) + "…" : title;

  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}">
  <rect width="${width}" height="${height}" fill="${palette.bg}"/>
  <text x="${width / 2}" y="${height / 2 - 10}" font-family="Arial,sans-serif" font-size="${fontSize}" font-weight="bold" fill="${palette.text}" text-anchor="middle" dominant-baseline="middle">${label}</text>
  <text x="${width / 2}" y="${height / 2 + fontSize}" font-family="Arial,sans-serif" font-size="${Math.floor(fontSize * 0.55)}" fill="${palette.text}" opacity="0.5" text-anchor="middle">AIVEO · IA ORIGINAL</text>
</svg>`;

  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}

// Handler onError para <img>
export function handleImgError(e, title, width = 800, height = 450) {
  e.target.onerror = null; // Evitar bucle infinito
  e.target.src = getSvgPlaceholder(title, width, height);
}
